import * as React from 'react';
import * as style from './ReviewItem.css';

export interface IReviewItemProps {
  author: React.ReactElement<unknown>;
  comment: React.ReactElement<unknown>;
  label: React.ReactElement<unknown> | false;
  answers: React.ReactElement<unknown> | false;
  readFullReviewLink: React.ReactElement<unknown>;
  reactions: React.ReactElement<unknown>;
}

export const ReviewItem: React.FC<IReviewItemProps> = ({
  author,
  comment,
  label,
  reactions,
  answers,
  readFullReviewLink,
}) => {
  return (
    <div className={style['wrapper']}>
      <div className={style['header']}>
        {author}
        {label}
      </div>

      <div className={style['content']}>{comment}</div>
      <div className={style['link']}>{readFullReviewLink}</div>

      <div className={style['footer']}>
        {reactions}
        {answers}
      </div>
    </div>
  );
};
